module.exports = Groupon.setWindowLocation = function(href) {
  window.location.href = href;
};

